import { useTransportControllers } from 'react-render-hooks';
import { ERequestIds } from 'react-memory-optimization/dist/lib/binary/types';

import {
  Text,
  CloseSvg,
  useZustandModalKitStore,
  zustandModalKitSelector,
  EModalTypes,
} from 'react-gldn-kit';

import styles from './CancelBonus.module.css';

type Props = {
  classes?: string;
  operationId: number;
  isImg?: boolean;
  isImmediately?: boolean;
  nameBonusKey: string;
};

const ButtonCancelBonus = (props: Props) => {
  const {
    classes,
    operationId,
    nameBonusKey,
    isImg,
    isImmediately = false,
  } = props;

  const { sendCommand } = useTransportControllers();

  const setModal = useZustandModalKitStore(
    zustandModalKitSelector.setModalInfoAction
  );

  const toggleCancelState = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();

    if (isImmediately) {
      handleCancelOperation();

      return;
    }

    setModal(EModalTypes.ClaimConfirmation, {
      id: operationId,
    });
  };

  const handleCancelOperation = () => {
    sendCommand(
      '23x',
      {
        operationId,
        requestId: ERequestIds.CancelOperation,
      },
      true
    );
  };

  return (
    <div className={classes}>
      <div className={styles.cancelCanceling} onClick={toggleCancelState}>
        {isImg ? <CloseSvg /> : <Text idT={nameBonusKey} />}
      </div>
    </div>
  );
};

export default ButtonCancelBonus;
